import styled from 'styled-components';
import { fontSize, fontWeight, radius, shadow, space } from '../../style/utils';

const ChartTooltip = styled.div`
  background: ${({ theme }) => theme.palette.surface.base};
  border-radius: ${radius('sm')};
  padding: ${space('xxl')};
  color: ${({ theme }) => theme.palette.content.primary};
  box-shadow: ${shadow('haze')};

  & p,
  & span {
    font-size: ${fontSize('base')};
    font-weight: ${fontWeight('regular')};
  }
`;

export default ChartTooltip;
